import React, { Component } from "react";
import { connect } from "react-redux";
import "./App.css";
import { Header, Icon } from "semantic-ui-react";
class AppBanner extends Component {
  genname() {
    if (!this.props.mobile) {
      return this.props.name;
    }
  }
  render() {
    console.log(this.props.route);
    return (
      <div id="appbanner" className="AppBanner">
        <Header as="h1">
          <Icon name={this.props.icon} />
          {this.genname()}
        </Header>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    name: state.route.name,
    icon: state.route.icon,
    mobile: state.mobile
  };
}
export default connect(mapStateToProps)(AppBanner);



// WEBPACK FOOTER //
// ./src/AppBanner.js